// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { accountTilesStyles } from "@guestsupply/App/Widgets/AccountTiles/AccountTiles";
import { color, ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

accountTilesStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 12px;
    `,
};
accountTilesStyles.infoSection = {
    css: css`
        display: flex;
        justify-content: flex-start;
        column-gap: 32px;
        row-gap: 8px;
        align-items: baseline;
        margin-bottom: 16px;

        ${xScreen("lte", "md")} {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
        }
    `,
};
accountTilesStyles.titleSection = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        ${xScreen("lte", "xs")} {
            margin-bottom: 5px;
        }
    `,
};
accountTilesStyles.title = {
    variant: "h4",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};
accountTilesStyles.greetingTitle = {
    variant: "h4",
    as: "p",
    css: css`
        margin-bottom: 0;
        margin-right: 3px;
    `,
};
accountTilesStyles.titleWrapper = {
    css: css`
        display: flex;
        align-items: center;
        column-gap: 10px;
        padding: 12px 12px 19px 12px;
        flex: 1;
    `,
};
accountTilesStyles.customerInfoWrapper = {
    css: css`
        display: flex;
        column-gap: 32px;
        row-gap: 10px;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

accountTilesStyles.customerInfo = {
    css: css`
        display: flex;
        column-gap: 4px;
        ${xScreen("lte", "xs")} {
            margin-bottom: 5px;
        }
    `,
};
accountTilesStyles.item = {
    title: {
        variant: "h5",
        as: "p",
        css: css`
            margin-bottom: 0;
            padding-top: 10px;
            text-wrap: wrap;
            ${ellipsis(2)}
        `,
    },
    link: {
        typographyProps: {
            size: 14,
            weight: "bold",
        },
    },
    imageContainer: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: ${color("common.ui2")};
            flex-basis: 62px;
            border-radius: 4px 0 0 4px;
        `,
    },
    number: {
        variant: "h2",
        as: "p",
        css: css`
            margin-bottom: 0px;
            text-wrap: nowrap;
        `,
    },
    imageWrapper: {
        css: css`
            width: 34px;
            height: 34px;
        `,
    },
    image: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
        `,
    },
};
accountTilesStyles.link = {
    typographyProps: {
        weight: "bold",
        size: 26,
    },
    icon: {
        iconProps: {
            css: css`
                margin-right: 12px;
            `,
        },
    },
};
accountTilesStyles.blockContent = {
    css: css`
        display: flex;
        box-sizing: border-box;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        background-color: ${color("common.background")};
        width: 100%;
        height: 100%;
    `,
};
accountTilesStyles.blocksGridContainer = {
    css: css`
        display: flex;
        padding: 5px;
    `,
};
accountTilesStyles.blockGridItem = {
    width: [12, 12, 6, 6, 3],
    css: css`
        display: flex;
        padding: 12px;
    `,
};
accountTilesStyles.clickable = {
    css: css`
        height: 100%;
        width: 100%;
        text-decoration: none;
    `,
};
accountTilesStyles.SmallHeadingAndText = {
    ...createHorizontalSmallHeadingAndTextStyles({
        heading: {
            size: 14,
            color: "text",
            weight: "bold",
            css: css`
                text-transform: capitalize;
            `,
        },
        text: {
            size: 14,
            color: "text",
        },
    }),
};
accountTilesStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};
